import { Helmet } from "react-helmet-async";

const PageSEO = ({ title }) => {
  const pageTitle = `${title} - Be With Law`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
  );
};

export default PageSEO;